import React, { useMemo } from 'react';
import { connect } from "react-redux";
import { Row, Col } from 'react-bootstrap';

const AssignedFarmList = props => {
    const { isRequesting, isOrganizationRequesting, farmList, assignedFarmIds, organizationListById,
        handleUnassignFarm, assignFarm } = props;

    const getFarmListById = (farmList, assignedFarmIds) => {
        const filteredFarmList = farmList.filter(item => assignedFarmIds.indexOf(item.farm_uuid) >= 0);

        const farmListByOrganizationId = filteredFarmList.reduce((objectsByKeyValue, obj) => {
            const value = obj.organization_uuid;
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

        return farmListByOrganizationId;
    }

    const farmListByOrganizationId = useMemo(() => getFarmListById(farmList, assignedFarmIds), [farmList, assignedFarmIds]);

    const handleUnassignOrganization = (organizationId) => {
        farmListByOrganizationId[organizationId].map(item =>
            assignedFarmIds.splice(assignedFarmIds.indexOf(item.farm_uuid), 1));
        assignFarm([...assignedFarmIds]);
    }

    return (isOrganizationRequesting || isRequesting || assignedFarmIds.length === 0
        ? <Col className="no-item-found">{isOrganizationRequesting || isRequesting ? "Loading..." : "This user does not belong to any farms"}</Col>
        : <Col className="assigned-farms">
            {Object.keys(farmListByOrganizationId).map(organizationId => {
                const organizationInfo = organizationListById[organizationId];
                const color = organizationInfo ? organizationInfo.theme_config.primary.main : "#002653";
                return organizationInfo && <React.Fragment key={organizationId}>
                    <Row className="field-title">
                        <Col className="m-auto">
                            <div className="splitter" style={{ background: color }} />
                        </Col>
                        <div style={{ color: color, borderColor: color }}
                            className="type d-flex">
                            <p className="name">{organizationInfo.organization_name}</p>
                            <i className="fa fa-times-circle" aria-hidden="true" title="Unselect"
                                onClick={() => handleUnassignOrganization(organizationId)}></i>
                        </div>
                        <Col className="m-auto">
                            <div className="splitter" style={{ background: color }} />
                        </Col>
                    </Row>
                    <Row>
                        {farmListByOrganizationId[organizationId].map(item => <div key={item.farm_uuid} className="farm-title d-flex"
                            style={{ background: color }}  >
                            <p className="name">{item.name}</p>
                            <i className="fa fa-times-circle" aria-hidden="true" title="Unselect"
                                onClick={() => handleUnassignFarm(item.farm_uuid)}></i>
                        </div>
                        )}
                    </Row>
                </React.Fragment>
            })}
        </Col >
    )
};

const mapStateToProps = state => {
    return ({
        farmList: state.users.farmList.payload,
        isOrganizationRequesting: state.organization.isOrganizationRequesting
    });
};

export default connect(mapStateToProps)(AssignedFarmList);